export default __webpack_public_path__ + "static/media/9.db979aa8.jpg";